<div [@visible]="visible" class="splash-wrap">
  <img src="/assets/branding/{{branding}}/logo-splash.png" class="splash-logo" alt="{{brandName}}">
</div>
